// src/components/AdminCoachPanel/coaches/ProfileImageUploader/ProfileImageUploader.js
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "./ProfileImageUploader.css";

export default function ProfileImageUploader({ initialImage, onUploadComplete }) {
  const fileInputRef = useRef(null);

  const [savedImage, setSavedImage] = useState(initialImage || null); // final URL from API
  const [tempImage, setTempImage] = useState(null);                   // dataURL while cropping
  const [imageElement, setImageElement] = useState(null);             // HTMLImageElement for canvas

  const [isCropping, setIsCropping] = useState(false);
  const [scale, setScale] = useState(1);
  const [minScale, setMinScale] = useState(1);


  // Position of the image inside the crop circle
  const [position, setPosition] = useState({ x: 1, y: 1 });
  const [dragging, setDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ mouseX: 0, mouseY: 0, x: 0, y: 0 });


  const [customFileName,setCustomFileName] = useState("")
  const [debugPreview, setDebugPreview] = useState(null);
  const [croppedFileSize, setCroppedFileSize] = useState(null); // in KB


  // sync initial image from parent
  useEffect(() => {
    if (initialImage && initialImage.length > 5) {
      setSavedImage(initialImage);
    }
  }, [initialImage]);

  // Load HTMLImageElement for canvas drawing when tempImage changes
// Load HTMLImageElement for canvas drawing when tempImage changes
// src/components/AdminCoachPanel/coaches/ProfileImageUploader/ProfileImageUploader.js

// Load HTMLImageElement for canvas drawing when tempImage changes
useEffect(() => {
  if (!tempImage) return;

  const img = new Image();
  img.src = tempImage;

  img.onload = () => {
    setImageElement(img);

    // 1. Match the CSS size (250px)
    const editorW = 250;
    const editorH = 250;

    const imgW = img.width;
    const imgH = img.height;

    // 2. Calculate two different scales
    // 'fitScale': The scale where the WHOLE image is visible (may have white bars)
    const fitScale = Math.min(editorW / imgW, editorH / imgH);
    
    // 'coverScale': The scale where the image FILLS the circle (parts cut off)
    const coverScale = Math.max(editorW / imgW, editorH / imgH);

    // 3. Set the slider limit to the 'fit' scale so you can zoom out fully
    setMinScale(fitScale);
    
    // 4. Start the initial zoom at 'fitScale' so the user sees the whole image immediately
    setScale(fitScale); 
    
    // 5. Center the image
    setPosition({ x: 0, y: 0 }); 
  };
}, [tempImage]);
  

  /* ==========================
     FILE SELECT
  ========================== */
  function handleFileSelect(e) {
    const file = e.target.files[0];
    if (!file) return;

    if (
      !file.type.includes("png") &&
      !file.type.includes("jpg") &&
      !file.type.includes("jpeg")
    ) {
      toast.error("Sadece JPG veya PNG yükleyebilirsiniz.");
      return;
    }

    if (file.size > 2 * 1024 * 1024) {
      toast.error("Resim maksimum 2 MB olabilir.");
      return;
    }

    setCustomFileName(file.name);


    const reader = new FileReader();
    reader.onload = (ev) => {
      setTempImage(ev.target.result);  // dataURL
      setIsCropping(true);
    };
    reader.readAsDataURL(file);
  }

  /* ==========================
     DRAG LOGIC (simple CSS transform)
  ========================== */
  function handleMouseDown(e) {
    e.preventDefault();
    setDragging(true);
    setDragStart({
      mouseX: e.clientX,
      mouseY: e.clientY,
      x: position.x,
      y: position.y,
    });
  }

  function handleMouseMove(e) {
    if (!dragging) return;
    e.preventDefault();

    const dx = e.clientX - dragStart.mouseX;
    const dy = e.clientY - dragStart.mouseY;

    setPosition({
      x: dragStart.x + dx,
      y: dragStart.y + dy,
    });
  }

  function handleMouseUp() {
    if (!dragging) return;
    setDragging(false);
  }

  /* ==========================
     CROP → CANVAS → COMPRESS
  ========================== */
  // async function generateCroppedBlob() {
  //   return new Promise((resolve) => {
  //     if (!imageElement) return resolve(null);

  //     const SIZE = 250; // square crop size
  //     const canvas = document.createElement("canvas");
  //     canvas.width = SIZE;
  //     canvas.height = SIZE;
  //     const ctx = canvas.getContext("2d");

  //     if (!ctx) return resolve(null);

  //     // White background (in case image has transparency)
  //     ctx.fillStyle = "#ffffff";
  //     ctx.fillRect(0, 0, SIZE, SIZE);

  //     // We treat the visible circle as a square of SIZE x SIZE.
  //     // The <img> is displayed with translate(position.x, position.y) and scale(scale).
  //     // We reproduce the same transform in canvas coordinates.

  //     const img = imageElement;
  //     const imgRatio = img.width / img.height;
  //     let baseWidth;
  //     let baseHeight;

  //     // Fit image so the smaller side fully covers the square
  //     if (imgRatio > 1) {
  //       // wider than tall
  //       baseHeight = SIZE;
  //       baseWidth = SIZE * imgRatio;
  //     } else {
  //       baseWidth = SIZE;
  //       baseHeight = SIZE / imgRatio;
  //     }

  //     const drawWidth = baseWidth * scale;
  //     const drawHeight = baseHeight * scale;

  //     // Center base, then apply user offset
  //     const centerX = SIZE / 2 + position.x;
  //     const centerY = SIZE / 2 + position.y;

  //     const sx = centerX - drawWidth / 2;
  //     const sy = centerY - drawHeight / 2;

  //     ctx.drawImage(img, sx, sy, drawWidth, drawHeight);

  //     // Now we have a square crop. (Frontend shows it as circle via CSS.)
  //     canvas.toBlob(
  //       (blob) => resolve(blob),
  //       "image/jpeg",
  //       0.9
  //     );
  //   });
  // }

  async function generateCroppedBlob() {
    return new Promise((resolve) => {
      if (!imageElement) return resolve(null);
  
      const SIZE = 250;
      const canvas = document.createElement("canvas");
      canvas.width = SIZE;
      canvas.height = SIZE;
      const ctx = canvas.getContext("2d");
      if (!ctx) return resolve(null);
  
      const img = imageElement;
  
      // Use scale directly (it's already absolute, not relative)
      const drawWidth = img.width * scale;
      const drawHeight = img.height * scale;
  
      const cx = SIZE / 2;
      const cy = SIZE / 2;
  
      const dx = cx - drawWidth / 2 + position.x;
      const dy = cy - drawHeight / 2 + position.y;
  
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, SIZE, SIZE);
      ctx.drawImage(img, dx, dy, drawWidth, drawHeight);
  
      canvas.toBlob((blob) => resolve(blob), "image/jpeg", 0.9);
    });
  }
  

  async function compressBlobTo100KB(blob) {
    if (!blob) return null;
    let currentBlob = blob;
    let quality = 0.9;

    while (currentBlob.size > 100 * 1024 && quality > 0.1) {
      currentBlob = await new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = 250;
          canvas.height = 250;
          const ctx = canvas.getContext("2d");
          if (!ctx) return resolve(null);

          ctx.fillStyle = "#ffffff";
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          canvas.toBlob(
            (b) => resolve(b),
            "image/jpeg",
            quality
          );
        };
        img.src = URL.createObjectURL(currentBlob);
      });
      if (!currentBlob) break;
      quality -= 0.1;
    }

    if (!currentBlob || currentBlob.size > 100 * 1024) {
      toast.error("Resim 100 KB altına düşürülemedi.");
      return null;
    }
    console.log("currentBlob.size",currentBlob.size);
    return currentBlob;
  }

  /* ==========================
     UPLOAD
  ========================== */
  async function handleSaveCrop() {
    const rawBlob = await generateCroppedBlob();
    console.log("rawBlob:", rawBlob);
    console.log("rawBlob size:", rawBlob.size);
  
    // 🔍 Preview cropped image before upload
    if (rawBlob) {
      const previewUrl = URL.createObjectURL(rawBlob);
      setDebugPreview(previewUrl);
    }
    if (!rawBlob) return;
    // DEBUG: Show preview before upload



    const blob = await compressBlobTo100KB(rawBlob);
    if (!blob) return;
    
    const sizeInKB = Math.round(blob.size / 1024);
    setCroppedFileSize(sizeInKB);


    const formData = new FormData();
    formData.append("FormFile", blob, "profile.png");
    // formData.append("Folder", "CoachPhotos");
    formData.append("Folder", "test");
    formData.append("FileName", customFileName);

    try {
      const token = sessionStorage.getItem("jwtP");
      const response = await axios.post(
        "https://contentprocess.tosanalytics.com/api/Mediafile/uploads",
        formData,
        {
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.responseStatus === 0) {
        toast.error("Yükleme başarısız: " + response.data.responseMessage);
        return;
      }

      const uploadedUrl = response.data.responseData[0].imageUrl;

      setSavedImage(uploadedUrl);
      onUploadComplete && onUploadComplete(uploadedUrl);
      setIsCropping(false);
      setTempImage(null);
      toast.success("Profil resmi güncellendi!");
    } catch (err) {
      console.error("Upload error:", err);
      toast.error("Dosya yüklenemedi.");
    }
  }

  /* ==========================
     RENDER
  ========================== */
  return (
    <div className="profile-upload-container">
      {/* CIRCLE PREVIEW */}
      {/* {debugPreview && (
  <div style={{ marginTop: 20 }}>
    <p>Cropped Preview:</p>
    <img
      src={debugPreview}
      alt="cropped preview"
      style={{
        width: 200,
        height: 200,
        borderRadius: "50%",
        border: "2px solid #333",
        objectFit: "cover",
      }}
    />
  </div>
)} */}

      <div
        className="profile-preview-circle"
        onClick={() => fileInputRef.current && fileInputRef.current.click()}
      >
        {savedImage ? (
          <img src={savedImage} alt="profile" className="profile-preview-img" />
        ) : (
          <div className="profile-placeholder">Upload</div>
        )}
       
      </div>
      {croppedFileSize !== null && (
  <div className="cropper-file-size">
    Dosya Boyutu:{" "}
    <strong
      className={
        croppedFileSize <= 100
          ? "file-size-ok"
          : "file-size-error"
      }
    >
      {croppedFileSize} KB
    </strong>
  </div>
)}

      {/* HIDDEN FILE INPUT */}
      <input
        type="file"
        ref={fileInputRef}
        accept="image/png, image/jpeg"
        style={{ display: "none" }}
        onChange={handleFileSelect}
      />

      {/* CROPPER OVERLAY */}
      {isCropping && tempImage && (
        <div
          className="cropper-overlay"
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
        >
          <div className="cropper-panel">
            <h3 className="cropper-title">Profil Fotoğrafını Kırp</h3>

            {/* Drag area */}
            <div
              className="cropper-frame"
              onMouseDown={handleMouseDown}
              onMouseMove={handleMouseMove}
            >
              
             

<div className="cropper-circle-mask">
  <img
    src={tempImage}
    alt="crop-source"
    className="cropper-image"
    style={{
      // CHANGED: Added translate(-50%, -50%) at the very start
      transform: `translate(-50%, -50%) translate(${position.x}px, ${position.y}px) scale(${scale})`,
    }}
    draggable={false}
  />
</div>
            </div>

            {/* Zoom slider */}
            <div className="cropper-slider-row">
              <span className="cropper-slider-label">Zoom</span>
              <input
  type="range"
  min={minScale}
  max={3}
  step="0.01"
  value={scale}
  onChange={(e) => setScale(parseFloat(e.target.value))}
  className="cropper-slider"
/>
            </div>

            {/* Buttons */}
            <div className="cropper-actions">
              <button
                type="button"
                className="cropper-btn cropper-btn-cancel"
                onClick={() => {
                  setIsCropping(false);
                  setTempImage(null);
                }}
              >
                İptal
              </button>
              <button
                type="button"
                className="cropper-btn cropper-btn-save"
                onClick={handleSaveCrop}
              >
                Kaydet
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
